function scroll() {
    const header = document.querySelector('.header');

    document.addEventListener('scroll', (e)=> {
        window.scrollY >= 100 ? header.classList.add('fixed') : header.classList.remove('fixed');
    });
}

export default scroll;